import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { navigationStep } from "../../../redux/slices/navigation";
import Navigation from "../../../components/navigation";
import SecondScreen from "../../SecondScreen";
import StepCustomize from "../../../components/stepCustomize";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { setLink } from "../../../redux/slices/getQrLinkSlice";
import { saveCrypto } from "../../../redux/slices/saveValue";
import Form from "react-bootstrap/Form";
import InputText from "../../../components/input/inputText";
import InputTextarea from "../../../components/input/inputTextarea";
import useTypeDecription from "../../../hooks/useTypeDecription";

const CRYPTO = ["Bitcoin", "Ethereum"];

export default function CryptoPage() {
  const { lang, valueCrypto } = useSelector((state) => ({
    lang: state.changeLang.language.stepTwo.crypto,
    valueCrypto: state.saveValue.valueCrypto,
  }));
  const navigate = useNavigate();
  const { content, getContent } = useTypeDecription();

  const [cryptoType, setCryptoType] = useState(
    valueCrypto[0] || CRYPTO[0].toLowerCase()
  );
  const [amount, setAmount] = useState("" || valueCrypto[1]);
  const [address, setAddress] = useState("" || valueCrypto[2]);
  const [message, setMessage] = useState("" || valueCrypto[3]);
  const [error, setError] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    getContent("crypto");
  }, []);

  function step() {
    if (amount && address.length) {
      setError(false);
      const addMessage = message ? `&message=${message}` : "";
      dispatch(
        setLink(
          `${cryptoType}:${address.replace(
            ",",
            "."
          )}?amount=${amount}${addMessage}`
        )
      );
      dispatch(saveCrypto([cryptoType, amount, address, message]));
      dispatch(navigationStep(3));
      navigate("/qr");
    } else {
      setError(true);
    }
  }

  return (
    <>
      <Navigation />
      <SecondScreen>
        <Form className="col-12 col-lg-6 mx-auto">
          <label className="fw-bold mb-2" htmlFor="cryptoType">
            {lang[0]}
            <RadioGroup
              row
              value={cryptoType}
              name="cryptoType"
              onChange={(e) => setCryptoType(e.target.value)}
            >
              {CRYPTO.map((item) => (
                <FormControlLabel
                  key={item}
                  value={item.toLowerCase()}
                  control={
                    <Radio
                      sx={{
                        "&.Mui-checked": {
                          color: "#9b27af",
                        },
                        "&": {
                          color: "#DDE0E4",
                        },
                      }}
                    />
                  }
                  label={item}
                />
              ))}
            </RadioGroup>
          </label>

          <InputText
            placeholder={lang[1]}
            type="number"
            name="amount"
            value={amount}
            min={0}
            onKeyDown={(e) =>
              ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
            }
            onChange={(e) => setAmount(e.target.value)}
            popoverText={lang[7]}
          >
            {error && !amount && (
              <Form.Text className="text-danger">{lang[2]}</Form.Text>
            )}
          </InputText>

          <InputText
            placeholder={lang[3]}
            name="address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            popoverText={lang[8]}
          >
            {error && !address.length && (
              <Form.Text className="text-danger">{lang[4]}</Form.Text>
            )}
          </InputText>

          <InputTextarea
            placeholder={lang[5]}
            name="message"
            value={message}
            maxLength={100}
            onChange={(e) => setMessage(e.target.value)}
            popoverText={lang[6]}
          />
        </Form>

        <StepCustomize emulate={step} disabled={!address.length || !amount} />
      </SecondScreen>

      {content}
    </>
  );
}
